/* eslint-disable */
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { http, type Meta } from "~/foundation/Api";
import { HistoricalTimelineResponse } from "~/project/AramcoLife/generated-types";

export const historicalTimelineServiceMeta: Meta<typeof historicalTimelineService> = {
	getHistoricalTimeline: ["GET", "/api/v1/historical-timeline/:dataSourceId"],
};

// Project.AramcoLife.Controllers.Api.ApiV1HistoricalTimelineController
export const historicalTimelineService = {
	async getHistoricalTimeline(dataSourceId: string) {
		return await http.fetch<HistoricalTimelineResponse, undefined>(historicalTimelineServiceMeta.getHistoricalTimeline, { params: { dataSourceId } });
	},
};
